export default __webpack_public_path__ + "static/media/Rear.51ed42ad.jpeg";